export default __webpack_public_path__ + "static/media/Linkedin.e8d1305b.svg";